/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_MusicInputs */

const en_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Music & Audio`)
};

const zh_hans1_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音乐与音频`)
};

const pt_br2_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Música e áudio`)
};

const es_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Música y audio`)
};

const fr_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musique et audio`)
};

const de_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musik & Audio`)
};

const ru_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Музыка и аудио`)
};

const it_category_music = /** @type {(inputs: Category_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musica e audio`)
};

/**
* | output |
* | --- |
* | "Music & Audio" |
*
* @param {Category_MusicInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_music = /** @type {((inputs?: Category_MusicInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_MusicInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_music(inputs)
	if (locale === "pt-BR") return pt_br2_category_music(inputs)
	if (locale === "es") return es_category_music(inputs)
	if (locale === "fr") return fr_category_music(inputs)
	if (locale === "de") return de_category_music(inputs)
	if (locale === "ru") return ru_category_music(inputs)
	if (locale === "it") return it_category_music(inputs)
	return en_category_music(inputs)
});